module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAATBJREFUOE+1lLFKw2AUhc9pO1hx6OBmCq4OgoNjBgVXwb0ZtFIyqoPg2Afo4OLY6hDo0sFH6GPUOaE4CBXqUEj/HIlQaJPUVGn//X73O//lXmJNj2viYHOgjrPnSmyR3Jm3lRSA0dm1N3zLSpEyatescRISFxK6FfggmJMsWArUcarK6lj3fD471s0y2MogBn75qo/JDBYac+h2hx+zpiuDIA1AvMeFEo4j4rzhBf2/gxJ5DXT6K6hds3zJ2CacfG6Vt0vhNFqYXswrsNgyxNNKRoSaEPdFXGZ9fq5Rx6mOCD2K6MOwwoKOkiAJF4a4y4s2Btij8KqidhHRThlRdgQ08qKNAFTyooXGHLjd4WDp1F4cqxYBTQhfIErQ4qr8FFK9uhfcz5tubmn/e1bWZvQNezWRExMOBSEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/userPage/note.png
// module id = btFv
// module chunks = 1